import NextJsUploadSourceMaps from "../../../../contents/docs/error-tracking/_snippets/nextjs-upload-source-maps.mdx";
import * as React from 'react';
export default {
  NextJsUploadSourceMaps,
  React
};